import {Component, Input} from '@angular/core';
import {UsefullLinkData} from "../../interfaces/usefull-link-data";

@Component({
  selector: 'brt-usefill-link',
  templateUrl: './usefill-link.component.html',
  styleUrls: ['./usefill-link.component.scss']
})
export class UsefillLinkComponent {

  @Input({required: true, alias: 'data'}) data!: UsefullLinkData;
}
